// Copyright (c) Microsoft Corporation. All rights reserved.
import { isStandardGamepad } from './isStandardGamepad';
/**
 * Checks if a supported controller is connected
 *
 * @param boolean allowNonstandardGamepad Check if the we allow nonstandard controllers
 */
export function isGamepadConnected(allowNonstandardGamepad) {
    var _a;
    if ((_a = globalThis.navigator) === null || _a === void 0 ? void 0 : _a.getGamepads) {
        return Array.from(globalThis.navigator.getGamepads()).some((gamepad) => {
            if (!gamepad || !gamepad.connected) {
                return false;
            }
            return allowNonstandardGamepad || isStandardGamepad(gamepad);
        });
    }
    return false;
}
//# sourceMappingURL=isGamepadConnected.js.map